// extracted by mini-css-extract-plugin
export default {"bar":"styles_bar__-U9T2","label":"styles_label__DQDun","cancelButton":"styles_cancelButton__2mylK","saveButton":"styles_saveButton__G5e4D"};